import React from 'react';
import { Form } from '@douyinfe/semi-ui';

const PageInfoForm = ({ pageInfo, onChange }) => {
    const onFormChange = (values) => {
        const newInfo = { ...pageInfo, ...values }
        onChange && onChange(newInfo)
    }
    return (
        <Form
            style={{ marginTop: '16px' }}
            initValues={pageInfo}
            onValueChange={onFormChange}
        >
            <Form.Input
                field="title"
                label="页面标题"
                placeholder="请输入页面标题"
                required
            />
            <Form.Input
                field="typ"
                label="页面分类"
                placeholder="请输入页面分类"
            />
            <Form.InputNumber
                field="sort"
                label="排序"
                placeholder="数值越大越靠前"
            />
            <Form.Select
                field="status"
                label="状态"
                optionList={[
                    { value: 0, label: '显示' },
                    { value: 1, label: '隐藏' }
                ]}
            />
        </Form>
    );
};

export default PageInfoForm;